window['PayPlusHostedFieldsDom'] = require("./PayPlusHostedFieldsDom").default